import { useSelector } from 'react-redux';
import moment from 'moment';
import { AppDatePicker } from '@/layout/AppComponents';
import BtnOptions from './BtnOptions';
import Translator from '../../../../components/helpers/Translator';

const Report44Options = (props) => {
  const {
    handleOnSetFieldValue,
    handleOnSubmit,
    handleOnSave,
    values,
    errors,
  } = props;
  const locale = useSelector((state) => state.global.urlData.lang);

  return (
    <>
      {errors?.plants && <div className="text-danger">*{errors?.plants}</div>}
      {errors?.plantGroups && (
        <div className="text-danger">*{errors?.plantGroups}</div>
      )}
      <div className="row">
        <div className="col-lg-6">
          <AppDatePicker
            title={
              <Translator
                file="module-lawFinder"
                name="module.lf.filter.from"
              />
            }
            locale={locale}
            value={values.from}
            onChange={(opt) => handleOnSetFieldValue('from', opt)}
            placeholder="dd/mm/yyyy"
            showMonthDropdown
            showYearDropdown
            isClearable
          />
        </div>
        <div className="col-lg-6">
          <AppDatePicker
            title={
              <Translator file="module-lawFinder" name="module.lf.filter.to" />
            }
            locale={locale}
            value={values.to}
            onChange={(opt) => handleOnSetFieldValue('to', opt)}
            minDate={
              values.from ? moment(values.from, 'DD/MM/YYYY').toDate() : false
            }
            placeholder="dd/mm/yyyy"
            showMonthDropdown
            showYearDropdown
            isClearable
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="row">
            <div className="col-12">
              <BtnOptions
                isDisabled={
                  !values.to ||
                  !values.from ||
                  errors?.plants ||
                  errors?.plantGroups
                }
                handleOnSave={() => handleOnSave(true)}
                handleOnSubmit={() => handleOnSubmit()}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Report44Options;
